import { render } from "./energyManager.vue?vue&type=template&id=671587bf&scoped=true"
import script from "./energyManager.vue?vue&type=script&lang=js"
export * from "./energyManager.vue?vue&type=script&lang=js"

import "./energyManager.vue?vue&type=style&index=0&id=671587bf&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-671587bf"]])

export default __exports__